import { render, staticRenderFns } from "./LinkAnprCameraItem.vue?vue&type=template&id=3afda83e"
import script from "./LinkAnprCameraItem.vue?vue&type=script&lang=js"
export * from "./LinkAnprCameraItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports